import React from 'react';
import { connect } from 'react-redux';
import ReactTable from 'react-table';
import { Helmet } from 'react-helmet';
import 'react-table/react-table.css';
import { BigBreadcrumbs, WidgetGrid, JarvisWidget } from '../../../components';
import { requestAssets, importData, requestAssetStatuses, deleteAsset } from '../../../store/asset-manager/AssetManagerActions';
import Pagination from '../../../components/common/Pagination';
import InfoBar from '../../../components/common/InfoBar';
import { hashHistory } from 'react-router';
import { hostTitle } from '../../../config/ui';
import { Modal } from 'react-bootstrap';
import Dropzone from 'react-dropzone';
import classNames from 'classnames';
import { toast } from 'react-toastify';
import { humanFileSize } from '../../../components/utils/format';
import { isExecutive } from '../../../store/current-user/CurrentUserSelectors';
import LocationsFilterForm from '../../resource-library/components/LocationsFilterForm';
import { requestClinicLocationsTypeahead } from '../../../store/location-manager/LocationManagerActions';

class AssetManager extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pageSize: 25,
      page: 0,
      pages: -1,
      search: '',
      sorted: [],
      filtered: [],
      selectedOption: 1,
      showModal: false,
      importFiles: [],
    };
    this.handleSearch = this.handleSearch.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.changeFilters = this.changeFilters.bind(this);
  }

  componentWillMount() {
    this.props.getAssetStatuses({
      tenantId: this.props.tenantId,
    });
  }

  handleChange(event) {
    this.setState({ selectedOption: event.target.value }, () =>
      this.table.fireFetchData(),
    );
  }

  fetchData = (state) => {
    const offset = state.page * state.pageSize;
    const limit = state.pageSize;
    const order = state.sorted
      .map((item) => `${item.desc ? 'desc' : 'asc'} ${item.id}`)
      .join();
    const filters = state.filtered
      .map((item) => `${item.value} ${item.id}`)
      .join();
    const search = this.state.search;
    return this.props
      .getAssets({
        offset: offset,
        limit: limit,
        order: order,
        search: search,
        filters: filters,
        tenantId: this.props.tenantId,
        locations: state.location ? state.location.provider : [],
        showValue: this.state.selectedOption,
      })
      .then((response) =>
        this.setState({
          pages: response.payload
            ? Math.ceil(response.payload.data.total / this.state.pageSize)
            : 0,
        }),
      );
  };

  handleSearch = (search) =>
    this.setState({ search, page: 0 }, () => this.table.fireFetchData());

  editAsset = (id, mode) => {
    hashHistory.push(`/asset-manager/asset/${id}/${mode}`);
  };

  detailAsset = (id, mode) => {
    hashHistory.push(`/asset-manager/asset/${id}/${mode}`);
  };

  addAsset = (id,mode) => {
    hashHistory.push(`/asset-manager/asset/${id}/${mode}`);
  };

  deleteAsset = (assetId) => {
    this.props
      .deleteAsset(assetId, {
        tenantId: this.props.tenantId,
      })
      .then(() => this.table.fireFetchData()
      );
  };

  searchLocations = (search) => {
    return this.props
      .locationsTypeahead({
        tenantId: this.props.tenantId,
        search,
      })
      .then((result) => {
        const options = [];
        if (result.payload.data) {
          result.payload.data.forEach((item) =>
            options.push({ code: item.code, name: item.name }),
          );
        }
        return options;
      });
  };

  changeFilters(params) {
    this.setState({ location: { ...this.location, ...params } }, () => this.fetchData(this.state));
  }
 
  import() {
    this.setState({ showModal: true });
  }

  onStartUpload() {
    this.props
      .importData(
        {
          tenantId: this.props.tenantId,
        },
        this.state.importFiles,
      )
      .then((result) => {
        if (result.error) {
          const message = _.get(result, 'payload.response.error.message', null);
          if (message) {
            toast.error(message);
          } else {
            toast.error('Something went wrong. Try again later.');
          }
        } else {
          toast.success('Data imported.');
          this.setState({ showModal: false, importFiles: [] }, () => this.table.fireFetchData());
        }
      });
  }

  showModal() {
    this.setState({ showModal: true });
  }

  closeModal() {
    this.setState({ showModal: false });
    this.onCancel();
  }

  onDrop(files) {
    if (this.state.importFiles.length === 0) {
      const filesToAdd = _.difference(files, this.state.importFiles);
      this.setState({
        importFiles: this.state.importFiles.concat(filesToAdd),
      });
    }
  }

  onCancel() {
    this.setState({
      importFiles: [],
    });
  }

  removeFileFromUploadList(fileName) {
    this.setState({
      importFiles: this.state.importFiles.filter(
        (file) => file.name !== fileName,
      ),
    });
  }

  render() {
    const { data, isExecutive, assetStatuses } = this.props;

    const filesToUpload = this.state.importFiles.map((file) => (
      <li className="list-group-item" key={file.name}>
        <span className="filename">{file.name}</span>
        <a
          className="action btn btn-xs btn-danger"
          onClick={() => this.removeFileFromUploadList(file.name)}
        >
          <i className="fa fa-close" />
        </a>
        <span className="badge">{humanFileSize(file.size)} bytes</span>
      </li>
    ));

    return (
      <div id="content">
        <Helmet title={`Asset Manager – ${hostTitle()}`} />
        <div className="table-layout content-ribbon">
          <div className="table-cell">
            <BigBreadcrumbs
              items={['Administration', 'Asset Manager']}
              icon="fa fa-fw fa-database"
              className=""
            />
          </div>
          <div className="table-cell">
            <InfoBar
              className=""
              total={data.total}
              pages={this.state.pages}
              page={this.state.page + 1}
            />
          </div>
        </div>
        <WidgetGrid>
          <div className="row">
            <article className="col-sm-12">
              <JarvisWidget
                color="white"
                fullscreenbutton={true}
                colorbutton={false}
                editbutton={false}
                togglebutton={false}
                deletebutton={false}
              >
                <header>
                  <span className="widget-icon">
                    {' '}
                    <i className="fa fa-table" />{' '}
                  </span>{' '}
                  <h2>Asset Manager</h2>
                  <div className="widget-toolbar">
                    <button disabled={isExecutive}
                      className="btn btn-primary btn-xs"
                      onClick={() => this.addAsset('00000000-0000-0000-0000-000000000000','Add')}
                    >
                      Add Asset
                    </button>
                    &nbsp;&nbsp;
                    <button disabled={isExecutive}
                      className="btn btn-primary btn-xs"
                      onClick={this.import.bind(this)}
                    >
                      Import
                    </button>
                  </div>
                </header>
                <div>
                  <div className="widget-body no-padding">
                    <div
                      style={{ padding: 10, borderBottom: '1px solid #eeeeee' }}
                    >
                      <div className="row">
                        <div className="col-md-2">
                            <select
                              className="form-control"
                              name="status"
                              value={this.state.selectedOption}
                              onChange={this.handleChange}
                            >
                              {assetStatuses &&
                                assetStatuses.map((el) => (
                                  <option key={el.id} value={el.id}>
                                    {el.name}
                                  </option>
                                ))}
                            </select>
                        </div>
                        <div className="col-md-1">
                        </div>
                        <div className="col-md-1" style={{ padding: 5 }}>
                          <strong> Location Filter </strong>
                        </div>
                        <div className="col-md-3" >
                          <LocationsFilterForm searchLocations={this.searchLocations} isMulti={true} onSubmit={this.changeFilters} />
                        </div>
                        
                      </div>
                    </div>
                    <ReactTable
                      ref={(instance) => {
                        this.table = instance;
                      }}
                      page={this.state.page}
                      manual
                      pages={this.state.pages}
                      loading={this.props.isLoading}
                      data={this.props.data ? this.props.data.list : []}
                      onFetchData={this.fetchData}

                      columns={[
                        {
                          Header: '',
                          id: 'actions',
                          width: 65,
                          sortable: false,
                          Cell: (row) => (
                            <span>
                              <button disabled={isExecutive}
                                className="btn btn-default btn-xs"
                                onClick={() =>
                                  this.editAsset(
                                    row.original.id,'Edit'
                                  )
                                }
                              >
                                <i className="fa fa-pencil" />
                              </button>
                              &nbsp;&nbsp;
                              <button disabled={isExecutive}
                                className="btn btn-default btn-xs"
                                onClick={() => this.deleteAsset(row.original.id)}>
                                <i className="fa fa-trash" />
                              </button>
                            </span>
                          ),
                        },
                        {
                          Header: 'ID',
                          id: 'id',
                          accessor: 'id',
                          show: false,
                        },
                        {
                          Header: 'AssetTagNo',
                          id: 'assetTagNo',
                          accessor: 'assetTagNo',
                          Cell: (row) => (
                            <a
                              onClick={() =>
                                this.detailAsset(
                                  row.original.id, 'ReadOnly'
                                )
                              }
                            >
                              {row.original.assetTagNo}
                            </a>
                          ),
                        },
                        {
                          Header: 'AssetName',
                          id: 'assetName',
                          accessor: 'assetName',
                        },
                        {
                          Header: 'Serial',
                          id: 'serial',
                          accessor: 'serial',
                        },
                        {
                          Header: 'Make',
                          id: 'make',
                          accessor: 'make',
                        },
                        {
                          Header: 'Model',
                          id: 'model',
                          accessor: 'model',
                        },
                        {
                          Header: 'AssetType',
                          id: 'assetType',
                          accessor: 'assetType.name',
                        },
                        {
                          Header: 'AssetCategory',
                          id: 'assetCategory',
                          accessor: 'assetCategory.name',
                        },
                        {
                          Header: 'Age',
                          id: 'age',
                          accessor: 'age',
                          width: 60
                        },
                        {
                          Header: 'Location',
                          id: 'location',
                          accessor: 'location.siteName',
                          width: 200
                        },
                      ]}
                      defaultPageSize={this.state.pageSize}
                      onPageSizeChange={(pageSize) =>
                        this.setState({ pageSize })
                      }
                      onPageChange={(page) => this.setState({ page })}
                      filterable
                      className="-striped -highlight"
                      showPaginationTop={true}
                      PaginationComponent={Pagination}
                      onSearchChange={this.handleSearch}
                    />


                    <Modal show={this.state.showModal}>
                      <Modal.Header>
                        <button
                          type="button"
                          className="close"
                          data-dismiss="modal"
                          aria-hidden="true"
                          onClick={this.closeModal.bind(this)}
                        >
                          &times;
                        </button>
                        <h4 className="modal-title" id="addFilesModalLabel">
                          Add Files
                        </h4>
                      </Modal.Header>
                      <Modal.Body>
                        <div className="row client-files-upload">
                          <div
                            className={
                              this.state.importFiles.length > 0
                                ? 'col-sm-12'
                                : 'col-sm-12'
                            }
                          >
                            <Dropzone
                              accept={".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"}
                              onDrop={this.onDrop.bind(this)}
                              onFileDialogCancel={this.onCancel.bind(this)}
                            >
                              {({
                                getRootProps,
                                getInputProps,
                                isDragActive,
                              }) => {
                                return (
                                  <div
                                    {...getRootProps()}
                                    className={classNames(
                                      'dropzone dropzone-client-files',
                                      { 'dropzone--isActive': isDragActive },
                                    )}
                                  >
                                    <input {...getInputProps()} />
                                    {isDragActive ? (
                                      <p>Drop files here...</p>
                                    ) : (
                                      <span className="text-center">
                                        <span className="font-lg visible-xs-block visible-sm-block visible-lg-block">
                                          <span className="font-lg">
                                            Drop files{' '}
                                            <span className="font-xs">
                                              to upload
                                            </span>
                                          </span>
                                          <span>
                                            &nbsp;&nbsp;
                                            <h4 className="display-inline">
                                              {' '}
                                              (Or Click)
                                            </h4>
                                          </span>
                                        </span>
                                      </span>
                                    )}
                                  </div>
                                );
                              }}
                            </Dropzone>
                          </div>
                          {this.state.importFiles.length > 0 && (
                            <div className="col-sm-12">
                              <h4>Files to be uploaded</h4>
                              <ul className="list-group files-upload-list">
                                {filesToUpload}
                              </ul>
                              {` `}
                              {this.state.importFiles.length === 1 && (
                                <h6 className="txt-color-red">Only one file per request accepted.</h6>
                              )}
                            </div>
                          )}
                        </div>
                      </Modal.Body>
                      <Modal.Footer>
                        <button
                          type="button"
                          className="btn btn-default"
                          data-dismiss="modal"
                          onClick={this.closeModal.bind(this)}
                        >
                          Cancel
                        </button>
                        <button
                          type="button"
                          className="btn btn-primary"
                          disabled={this.state.importFiles.length === 0}
                          onClick={this.onStartUpload.bind(this)}
                        >
                          Import Data
                        </button>
                      </Modal.Footer>
                    </Modal>

                  </div>
                </div>
              </JarvisWidget>
            </article>
          </div>
        </WidgetGrid>
      </div>
    );
  }
}

export default connect(
  (state) => ({
    ...state.assetmanager,
    tenantId: state.currentUser.queryParams.tenantId,
    isExecutive: isExecutive(state),
  }),
  (dispatch) => ({
    getAssets: (params) => dispatch(requestAssets(params)),
    importData: (params, files) => dispatch(importData(params, files)),
    getAssetStatuses: (params) => dispatch(requestAssetStatuses(params)),
    deleteAsset: (assetId, params) => dispatch(deleteAsset(assetId, params)),
    locationsTypeahead: (params) => dispatch(requestClinicLocationsTypeahead(params)),
  }),
)(AssetManager);



// WEBPACK FOOTER //
// ./src/routes/administration/containers/AssetManager.js